module.exports = __webpack_public_path__ + "static/img/openFlower3.592b8b90.jpeg";